import { Action } from '@ngrx/store';
import { QueryParamsModel } from '../../_base/crud';
import { CategoryDescription } from '../_models/category-description.model';

export enum CategoryDescriptionActionTypes {
  CategoryDescriptionOnServerDeleted = '[CategoryDescription] CategoryDescription On Server Deleted',
  CategoryDescriptionDeleted = '[CategoryDescription] CategoryDescription Deleted',
  CategoryDescriptionPageRequested = '[CategoryDescription] CategoryDescription Page Requested',
  CategoryDescriptionPageLoaded = '[CategoryDescription] CategoryDescription Page Loaded',
  CategoryDescriptionPageCancelled = '[CategoryDescription] CategoryDescription Page Cancelled',
  CategoryDescriptionPageToggleLoading = '[CategoryDescription] CategoryDescription Page Toggle Loading',
  CategoryDescriptionActionToggleLoading = '[CategoryDescription] CategoryDescription Action Toggle Loading',
  ThrowCategoryDescriptionError = '[CategoryDescription] Throw Error',
  FireCategoryDescriptionSuccess = '[CategoryDescription] Fire Success',
}

export class ThrowCategoryDescriptionError implements Action {
  readonly type = CategoryDescriptionActionTypes.ThrowCategoryDescriptionError;

  constructor(public payload: { error: any }) {}
}

export class FireCategoryDescriptionSuccess implements Action {
  readonly type = CategoryDescriptionActionTypes.FireCategoryDescriptionSuccess;

  constructor(public payload: { action_type: string }) {}
}

export class CategoryDescriptionOnServerDeleted implements Action {
  readonly type = CategoryDescriptionActionTypes.CategoryDescriptionOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class CategoryDescriptionDeleted implements Action {
  readonly type = CategoryDescriptionActionTypes.CategoryDescriptionDeleted;

  constructor(public payload: { id: number }) {}
}

export class CategoryDescriptionPageRequested implements Action {
  readonly type = CategoryDescriptionActionTypes.CategoryDescriptionPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class CategoryDescriptionPageLoaded implements Action {
  readonly type = CategoryDescriptionActionTypes.CategoryDescriptionPageLoaded;

  constructor(
    public payload: {
      categoryDescription: CategoryDescription[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class CategoryDescriptionPageCancelled implements Action {
  readonly type = CategoryDescriptionActionTypes.CategoryDescriptionPageCancelled;
}

export class CategoryDescriptionPageToggleLoading implements Action {
  readonly type = CategoryDescriptionActionTypes.CategoryDescriptionPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class CategoryDescriptionActionToggleLoading implements Action {
  readonly type = CategoryDescriptionActionTypes.CategoryDescriptionActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export type CategoryDescriptionActions =
  | CategoryDescriptionDeleted
  | CategoryDescriptionOnServerDeleted
  | CategoryDescriptionPageLoaded
  | CategoryDescriptionPageCancelled
  | CategoryDescriptionPageToggleLoading
  | CategoryDescriptionPageRequested
  | ThrowCategoryDescriptionError
  | FireCategoryDescriptionSuccess
  | CategoryDescriptionActionToggleLoading;
